export default {
  // 模块名称
  changeJob: {
    // 按钮类
    button: {
      query: 'Query',
      reset: 'Reset',
      export: 'Export',
      close: 'Close',
      detail: 'Detail'
    },
    // 文字标签类
    label: {
      jobNumber: 'Job Number',
      image: 'Photo',
      name: 'Name',
      isDuty: 'On Duty/Lay Off',
      post: 'Post',
      postType: 'PostType',
      time: 'Time',
      operations: 'Operations',
      to: 'To'
    },
    // 提示类
    placeholder: {
      select: 'Select',
      startDate: 'Start Date',
      endDate: 'End Date'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: 'Record details'
    }
  }
}